import { Link, useLocation } from 'react-router'
import { ScrollArea } from '@/components/ui/scroll-area'
import { cn } from '@/lib/utils'
import { useSession } from '@/hooks/useSession'
import { sectionOf, sectionsFor } from './nav'

// 사이드바는 **레일에서 고른 섹션의 상세 메뉴만** 그린다. 대분류를 다시 그리지 않는다.
// 클러스터 → 노드의 계층은 물리 자원의 성질이라 클러스터 화면 본문이 갖는다 — 여기 두지 않는다.

export function Sidebar() {
  const { pathname } = useLocation()
  const { role } = useSession()
  const here = sectionOf(pathname)
  const section = sectionsFor(role).find((s) => s.id === here.id) ?? { ...here, items: [] }

  return (
    <aside className="flex h-full w-60 flex-none flex-col border-r bg-surface">
      <div className="flex h-14 flex-none items-center px-5 text-[13px] font-semibold tracking-tight">
        LCCS
      </div>

      <ScrollArea className="min-h-0 flex-1">
        <nav className="px-3 pb-6">
          <p className="px-3 pt-2 pb-1.5 text-[10px] font-semibold tracking-[0.12em] text-muted-foreground uppercase">
            {section.label}
          </p>

          {section.items.map((item) => {
            const Icon = item.icon
            const on = item.match(pathname)
            return (
              <Link
                key={item.to}
                to={item.to}
                className={cn(
                  'mb-0.5 flex items-center gap-2.5 rounded-full px-3 py-2 text-[13px] transition-colors',
                  on
                    ? 'bg-brand font-medium text-white'
                    : 'text-muted-foreground hover:bg-surface-2 hover:text-foreground',
                )}
              >
                <Icon className="size-4 flex-none" />
                {item.label}
              </Link>
            )
          })}
        </nav>
      </ScrollArea>
    </aside>
  )
}
